import React, {Component} from "react";
import { inject, observer } from "mobx-react";
import DataWrapper from '../../principal/containers/DataWrapper';
import LotesPagamentoStore from "../stores/LotesPagamentoStore";
import {
    formatarDataISO8601, formatarValorReal, nullable, ordenarData,
    formatarDataHoraISO8601
} from "../../../utils/formatar";
import {sortAlphaNum} from "../../../utils/ordenar";
import {getStatusLotePagamentoById} from "../../../utils/enums";
import {LotesPagamentoFiltro} from "../components/LotesPagamentoFiltro";
import {Button} from "reactstrap";
import FontAwesome from 'react-fontawesome'
import {TabelaFluxo} from "../../comum/components/TabelaFluxo";
import {LoadingBlockFields} from  "../../comum/components/LoadingBlockFields";

@inject("store")
@DataWrapper
@observer
export class LotesPagamento extends Component {

    constructor(props) {
        super(props);
        this.appStore                   = this.props.store.appStore;
        this.tituloPaginaStore          = this.props.store.tituloPaginaStore;
        this.modalStore                = this.props.store.modalStore;
        this.loginStore                 = this.props.store.loginStore;
        /* Selecionar Controller */
        this.controller                 = new LotesPagamentoStore();

        this.acaoReenviar          = this.acaoReenviar.bind(this);
    }

    componentDidMount() {
        this.controller.carregarDados();
        this.tituloPaginaStore.setTitulo("Lotes de pagamento");

        this.controller.carregarTabela();

        this.tituloPaginaStore.setBotoesMobile([
            {
                label: "Ordenar",
                icone: "sort",
                acao: () => this.modalStore.toggleModal('ordenar')
            },{
                label: "Filtrar",
                icone: "search",
                acao: () => this.modalStore.toggleModal('filtrar')
            }
        ]);
    }

    formatarStatus = (valor) => {
        const status = getStatusLotePagamentoById(valor);

        return status.valor;
    };

    obterTituloMobile = (objeto) => {
        return  "Lotes " + objeto.id;
    };

    obterConteudoMobile = (objeto) => {
        return (
            <div>
                { "Unidade de negócio (BU): " + nullable(objeto.nomeEmpresaGlobo)}<br/>
                { "Qtde MOTs: " + nullable(objeto.quantidadeMOTs)}<br/>
                { "Valor total: " + nullable(formatarValorReal(objeto.valorTotal))}<br/>
                { "Data geração: " +  nullable(formatarDataISO8601(objeto.dataGeracao))}<br/>
                { "Nota fiscal: " + nullable(objeto.numeroNotasFiscais)}<br/>
                { "Data de emissão da nota fiscal: " + nullable(objeto.dataEmissaoNotasFiscais)}<br/>
                { "Status: " + nullable(objeto.status)}<br/>
                { this.loginStore.isPerfilAdministradorLogado &&
                <div>
                    {"ETT: " +  nullable(objeto.nomeEtt) }<br/>
                    {"Data integração: " + nullable(objeto.dataHoraEnvioEBS)}<br/>
                    {"Erro integração: " + nullable(objeto.erroIntegracaoEBS)}<br/>
                    {"Número RC: " + nullable(objeto.numeroRc)}<br/>
                    {"Número OC: " + nullable(objeto.numeroOc)}
                </div>
                }
            </div>
        )
    };

    acaoBotao = (row, itemAcao, i, tipo) => {
        let display = this.controller.displayButton(row);

       if (tipo === "reenviar"){
            return (
                <Button
                    key={i}
                    title={itemAcao.label}
                    style={
                        {
                            display: this.loginStore.isPerfilAdministradorLogado ? display : "none"
                        }
                    }
                    className={"icon-button " + itemAcao.cor}
                    onClick={
                        () => {
                            //colocar a acao aqui
                            this.controller.reenviarLotePagamento(row.id);
                        }
                    }
                >
                    <FontAwesome
                        name={itemAcao.icone}
                        flip={itemAcao.flip}
                    />
                </Button>
            );
        }
    }

    acaoReenviar(row, itemAcao, i){
        return this.acaoBotao(row, itemAcao, i, 'reenviar');
    }

    render() {
        const COLUNAS = this.loginStore.isPerfilAdministradorLogado ? [
            {
                field: "id",
                label: "Lote",
                funcaoOrdenacao: sortAlphaNum.bind("id")
            },{
                field: "nomeEmpresaGlobo",
                label: "Unidade de negócio (BU)"
            },{
                field: "quantidadeMOTs",
                label: "Qtde MOTs",
                funcaoOrdenacao: sortAlphaNum.bind("quantidadeMOTs")
            },{
                field: "valorTotal",
                label: "Valor total",
                dataFormat: formatarValorReal,
                funcaoOrdenacao: sortAlphaNum.bind("valorTotal")
            },{
                field: "dataGeracao",
                label: "Data geração",
                dataFormat: formatarDataISO8601,
                funcaoOrdenacao: ordenarData.bind("dataGeracao")
            },{
                field: "nomeEtt",
                label: "ETT"
            },{
                field: "numeroNotasFiscais",
                label: "Nota fiscal",
                style: {width: "122px", whiteSpace: 'normal'}
            },{
                field: "dataEmissaoNotasFiscais",
                label: "Data de emissão da nota fiscal"
            },{
                field: "status",
                label: "Status",
                dataFormat: this.formatarStatus
            },{
                field: "dataHoraEnvioEBS",
                label: "Data integração",
                dataFormat: formatarDataHoraISO8601,
                funcaoOrdenacao: ordenarData.bind("dataHoraEnvioEBS")
            },{
                field: "erroIntegracaoEBS",
                label: "Erro integração"
            },{
                field: "numeroRc",
                label: "Número RC/número OC",
                funcaoOrdenacao: sortAlphaNum.bind("numeroRC")
            }
        ] : [
            {
                field: "id",
                label: "Lote",
                funcaoOrdenacao: sortAlphaNum.bind("id")
            },{
                field: "nomeEmpresaGlobo",
                label: "Unidade de negócio (BU)"
            },{
                field: "quantidadeMOTs",
                label: "Qtde MOTs",
                funcaoOrdenacao: sortAlphaNum.bind("quantidadeMOTs")
            },{
                field: "valorTotal",
                label: "Valor total",
                dataFormat: formatarValorReal,
                funcaoOrdenacao: sortAlphaNum.bind("valorTotal")
            },{
                field: "dataGeracao",
                label: "Data geração",
                dataFormat: formatarDataISO8601,
                funcaoOrdenacao: ordenarData.bind("dataGeracao")
            },{
                field: "numeroNotasFiscais",
                label: "Nota fiscal",
                style: {width: "122px", whiteSpace: 'normal'}
            },{
                field: "dataEmissaoNotasFiscais",
                label: "Data de emissão da nota fiscal"
            },{
                field: "status",
                label: "Status",
                dataFormat: this.formatarStatus
            }
        ];

        /* Especificar botões nos itens da tabela (Se houverem) */
        const acoesItens = [];

        acoesItens.push({
            tipo: "reenviar",
            label: "Reenviar",
            icone: "send-o",
            cor: "text-info",
            parametro: "id",
            acao: this.acaoReenviar
        });

        acoesItens.push({
            tipo: "visualizar",
            label: "Visualizar",
            icone: "search-plus",
            cor: "text-info",
            parametro: "id",
            acao: "/detalhes-lote-pagamento"
        });

        return (
            <div>
                <div className="form-wrapper">
                    <div className={this.appStore.width > 768 ? "content-panel" : ""}>
                        {this.appStore.width > 768 && <LotesPagamentoFiltro controller={this.controller} loginStore={this.loginStore} filtrarStatus={true}/>}
                        <LoadingBlockFields carregando={this.controller.carregando}>
                            <TabelaFluxo
                                keyField={"id"}
                                habilitarSelecaoMultipla={false}
                                listaItens={this.controller.lotesLista}
                                colunas={COLUNAS}
                                temBusca={true}
                                acoesItens={acoesItens}
                                tituloMobile={(row) => this.obterTituloMobile(row)}
                                conteudoMobile={(row) => this.obterConteudoMobile(row)}
                                onChange={(value) => this.controller.setLista(value)}
                                loading={this.controller.loading}
                                colunaOrdenacaoPadrao={"id"}
                                nomeFluxo={'Lotes pagamento'}
                                onCardClick={this.props.onCardClick}
                                tipoOrdenacaoPadrao={'asc'}
                                mobileFilter={<LotesPagamentoFiltro controller={this.controller} loginStore={this.loginStore} filtrarStatus={true}/>}
                            />
                        </LoadingBlockFields>
                    </div>
                </div>
            </div>
        );
    }
}

